import { authHeader } from '@/_helpers';
export const myCalendarService = {
    getAvailabilityByDay,
    getAvailabilityByMonth,
    createEventInCalendar,
    updateEventCalendar,
    cancelEventCalendar,
    getEvent,
    getLandingLink,
    getLanguageId,
    saveTimeAndHour,
    saveTimeAvailable,
    getCalendars,
    userCalendarAvailable,
    insertActivity,
    unsubscribe,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getAvailabilityByMonth(month,year,account_id,time_zone) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({month,year,account_id,time_zone}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/availability-month`, requestOptions).then(handleResponse);
}

function insertActivity(hash, business_contact_id, calendar, calendar_url) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hash, business_contact_id, calendar , calendar_url}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/insertactivity`, requestOptions).then(handleResponse);
}

function unsubscribe(data) {
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...data }),
      credentials: 'include', // include, same-origin, omit
  };
  return fetch(`${apiUrl}/calendar/activity`, requestOptions).then(handleResponse);
}

function getLandingLink(domain) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({domain}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/get-landing-link`, requestOptions).then(handleResponse);
}


function userCalendarAvailable(account_id) {

  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({account_id}),
      credentials: 'include', // include, same-origin, omit
  };
  return fetch(`${apiUrl}/calendar/user-calendar-available`, requestOptions).then(handleResponse);
}

function getAvailabilityByDay(day,month,year,account_id,time_zone,s) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({day,month,year,account_id,time_zone,s}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/availability-day`, requestOptions).then(handleResponse);
}

function saveTimeAvailable(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(data)
    };
    return fetch(`${apiUrl}/users/config_time_available`, requestOptions).then(handleResponse);
}

function saveTimeAndHour(data) {
  const requestOptions = {
      method: 'POST',
      headers: authHeader('application/json'),
      body: JSON.stringify({data})
  };
  return fetch(`${apiUrl}/users/save-timezone-hour`, requestOptions).then(handleResponse);
}


function getLanguageId(account_id) {

  // Devuelve una promesa que resuelve con el array simulado
  return new Promise((resolve, reject) => {
    resolve(2);
  });

}

// function encriptar(texto, clave) {
//   let resultado = '';
//   for (let i = 0; i < texto.length; i++) {
//     resultado += String.fromCharCode(texto.charCodeAt(i) ^ clave.charCodeAt(i % clave.length));
//   }
//   return resultado;
// }
function encriptar(data, clave) {
    const texto = JSON.stringify(data);
    let resultado = '';

    for (let i = 0; i < texto.length; i++) {
      resultado += String.fromCharCode(texto.charCodeAt(i) ^ clave.charCodeAt(i % clave.length));
    }

    return resultado;
  }

function createEventInCalendar(data) {
   // let event = encriptar(data,"230525ae56abdbf8c00131e20cc1b943");

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({data}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/create-event`, requestOptions).then(handleResponse);
}

function updateEventCalendar(event_id,title,email,textArea,year,month,day,hour,meetType,name) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({event_id,title,email,textArea,year,month,day,hour,meetType,name}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/update-event`, requestOptions).then(handleResponse);
}

function cancelEventCalendar(event_id,title,email,textArea,year,month,day,hour,meetType,name) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({event_id}),
        credentials: 'include', // include, same-origin, omit
    };
    return fetch(`${apiUrl}/calendar/cancel-event`, requestOptions).then(handleResponse);
}

function getEvent(event_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({event_id})
    };
    return fetch(`${apiUrl}/calendar/event`, requestOptions).then(handleResponse);
}
function getCalendars(accountId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({accountId})
    };
    return fetch(`${apiUrl}/calendar/getallcalendars`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

